module.exports = __webpack_public_path__ + "../resources/img/ic_re_wifi_on_default.c5a6f212.svg";